export const theme = {
  black: '#072626',
  blackHover: '#093838',
  white: '#FFFFFF',
  lightOrange: '#FCEADE',
  orange: '#FF8A5B',
  pink: '#EA526F',
  fontLight: 300,
  fontBold: 700,
  green: '#69BF53',
  red: '#FF2E2E',
  lightGreen: '#E4FCDE',
  fontSize: {
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.6rem',
    m: '2.1rem',
    l: '2.4rem',
    xl: '4rem',
  },
};
